module.exports = __webpack_public_path__ + "img/gold-icon.4b690ca9.png";